import { Injectable } from '@angular/core';
import { FirestoreRepository } from '@core/services';
import { PortalUser } from './state/portalUsers.firebase.models';

@Injectable({
	providedIn: 'root',
})
export class PortalUsersRepo extends FirestoreRepository<PortalUser> {
	constructor() {
		super('portalUsers');
	}
}
